const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class S3Upload extends DataServiceEndPoint {
  static key = "S3Upload"

  getPresignedUrl = async ({ agentId, contentType }) => {
    const url = `${this.url}/v1/s3-upload/generate-presigned-url`
    const headers = { Authorization: `bearer ${this.token}` }
    try {
      const payload = { agentId, contentType }
      const result = await this._httpService.post(url, payload, { headers })
      return { data: result?.data }
    } catch (error) {
      this._logger.error(`[DATA] Failed to get presigned URL for S3 upload`, error)
      throw error
    }
  }
}
module.exports = S3Upload
